import { rpcClient } from "@/api/WebsocketClient"
import SWR, { Call } from "@/api/SWR"
import { reactive } from "@vue/reactivity"
import SortAndFilterUtil from "@/util/SortAndFilterUtil"
import MailDomain from '@/model/settings/MailDomain';
import Page from '@/model/Page';
import { mailDomainStore } from '@/store/MailDomainStore';

export default class GeneratedMailDomainServiceApi {

    cache: Map<string, Call<any>> = new Map<string, Call<any>>()

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.apis.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        this.cache = new Map<string, Call<any>>()
    }

    get connected(): boolean {
        return rpcClient.state.connected
    }

    _getMailDomains(): Promise<MailDomain[]> {
        let rpcParams: any[] = Array.prototype.slice.call(arguments, 0, arguments.length).filter(arg => arg !== undefined)
        return rpcClient.call('getMailDomains', rpcParams, true).then((data: any) => {
            if (data && Array.isArray(data)) {
                const mailDomains: MailDomain[] = data.map(mailDomain => Object.assign(new MailDomain(), mailDomain))
                mailDomainStore.replaceMailDomains(mailDomains)
                return mailDomains
            } else return Promise.reject()
        })
    }


    getMailDomains(refresh?: boolean | number): SWR<MailDomain[], string[]> {
        //@ts-ignore
        const result: SWR<MailDomain[], string[]> = reactive(new SWR<MailDomain[], string[]>())
        const args: any[] = Array.prototype.slice.call(arguments, 0, 0).filter(arg => arg !== undefined)
        const callId: string = '_getMailDomains' + JSON.stringify(args)
        const cached: Call<string[]> | undefined = this.cache.get(callId)
        if (refresh === undefined && cached && cached.ended) {
            for (const [ id, call ] of this.cache) {
                if (id.startsWith('_getMailDomains[') && id !== callId && (!call.ended || call.ended > cached.ended)) {
                    refresh = 3000
                    break
                }
            }
        }
        if (cached && !cached.ended) {
            result.call = cached
            cached.promise?.then((data: string[]) => {
                const mailDomains: MailDomain[] = []
                for (const id of data) {
                    const mailDomain: MailDomain | undefined = mailDomainStore.state.mailDomains.get(id)
                    if (mailDomain) {
                        mailDomains.push(mailDomain)
                    }
                }
                result.data = mailDomains
            })
        } else if (refresh !== -1 && (!cached || refresh === true || (typeof refresh === 'number' && (cached.ended || 0) < (Date.now() - refresh)))) {
            const call = reactive(new Call<string[]>()) as Call<string[]>
            this.cache.set(callId, call)
            call.loading = !cached
            call.refreshing = !!cached
            //@ts-ignore since Array.filter does not provide nullsafe guard
            call.promise = this._getMailDomains().then((data: MailDomain[]) => {
                //@ts-ignore since Array.filter does not provide nullsafe guard
                result.data = data
                //@ts-ignore since Array.filter does not provide nullsafe guard
                call.data = data.map(mailDomain => mailDomain.name || '')
                return call.data
            }).catch(e => {
                setTimeout(() => {
                  this.cache.delete(callId)
                }, 1000)
                return Promise.reject(e)
            }).finally(() => {
                call.ended = Date.now()
                call.loading = false
                call.refreshing = false
            })
            result.call = call
        }
        let mailDomains: MailDomain[] = [...mailDomainStore.state.mailDomains.values()]
        
        
        
        result.data = mailDomains
        return result
    }

    getMailDomain(name: string): MailDomain | undefined {
        return mailDomainStore.state.mailDomains.get(name)
    }
}
